import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { aCodigosBackend } from '../../Models/coberturaOpcional';
import { Cotizacion } from '../../Models/cotizacion';
import { CotizacionEnvio } from '../../Models/cotizacionEnvio';
import { UtilsService } from '../utils.service';

@Injectable({
  providedIn: 'root'
})
export class CotizacionService {

  baseUri = environment.URL_COTIZACION;
  _body = {};

  constructor(
    private http: HttpClient,
    private utils: UtilsService
  ) { }

  public postCrearLeads(dataLead: any, sessionId: string): Observable<any> {
    let data = JSON.stringify(dataLead);
    this._body = JSON.parse(data);
    const headers = this.utils.getHeaders(sessionId);
    return this.http.post<any>(this.baseUri, this._body, { headers: headers });
  }

  public postCrearCotizacion(infoPlan: CotizacionEnvio, sessionId: string): Observable<Cotizacion>{
    const payload = {
      ...infoPlan,
      coberturasOpcionales: aCodigosBackend(infoPlan.coberturasOpcionales),
    };
    let data = JSON.stringify(payload);
    this._body = JSON.parse(data);
    const headers = this.utils.getHeaders(sessionId);
    return this.http.post<Cotizacion>(this.baseUri, this._body, { headers: headers });
  }

  // metodo get para obtener la cotizacion
  public getCotizacion(sessionId: string, parameter:string): Observable<Cotizacion> {
    const headers = this.utils.getHeaders(sessionId);
    return this.http.get<Cotizacion>(this.baseUri + '/' + parameter, { headers: headers, });
  }
}
